import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ManageQtyLayer from "../../components/Settings/ManageQtyLayer";

const ManageQtyPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Manage Quantity Settings" />
      <ManageQtyLayer />
    </MasterLayout>
  );
};

export default ManageQtyPage;
